import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    loading: false
  },
  getters: {
    list: state => state.list,
    details: state => state.details,
    loading: state => state.loading
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("CMS/api/BannersQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("CMS/api/Banners", model);
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "CMS/api/Banners",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          //dispatch('fetch')
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("CMS/api/Banners", model).then(() => {
        //dispatch('fetch')
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
};
